import { render, staticRenderFns } from "./QuesStarRating.vue?vue&type=template&id=76321732&scoped=true&"
import script from "./QuesStarRating.vue?vue&type=script&lang=js&"
export * from "./QuesStarRating.vue?vue&type=script&lang=js&"
import style0 from "./QuesStarRating.vue?vue&type=style&index=0&id=76321732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76321732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCol,VFileInput,VRating,VRow,VTextField,VTextarea})
